import styled from "styled-components";

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2em;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #cc0000;
  border-radius: 10px;
  padding: 30px 20px 10px;
  background-color: #ffffff;
`;

export const Title = styled.h2`
  margin: 0em 0 1em;
  color: #cc0000;
`;

export const TopImageContainer = styled.div`
  margin-bottom: 15px;
`;

export const BottomImageContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BottomImageItem = styled.div`
  flex: 1;
`;

export const TextImage = styled.h2`
  margin-top: 10px;
  text-align: center;

  @media (max-width: 768px) {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 15px;
  }
`;

export const ResponsiveImage = styled.img`
  width: 100%;
  height: auto; /* Altezza calcolata automaticamente per mantenere le proporzioni */
  border-radius: 5px;
  object-fit: cover; /* Garantisce che l'immagine riempia il contenitore */
`;
